<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <section class="section-prices">
            <div class="lds-ring" v-if="!isLoad">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            <form v-if="isLoad">
              <div class="page-title page-title_price">
                <div class="climbing-head__rows">
                  <div class="climbing-head__first-row">
                      <div class="select__fields-group">
                        <span class="select-label">Operator:</span>
                        <ClassicSelect :items="formattedOperators" @select-item="(v) => this.operatorSelectedValue = v" />
                      </div>
                      <div class="select__fields-group">
                        <span class="select-label">Permit Type:</span>
                        <ClassicSelect :items="permitTypeSelectData" @select-item="(v) => this.permitTypeSelectedValue = v" />
                      </div>
                      <div class="select__fields-group">
                        <span class="select-label">Age:</span>
                        <ClassicSelect :items="ageSelectData" @select-item="(v) => this.ageSelectedValue = v"/>
                      </div>
                    <div class="select__fields-group">
                      <span class="select-label">Year:</span>
                      <ClassicSelect custom-width="10rem" :selected-item="yearSelectValue" :items="formattedYears" @select-item="(v) => this.yearSelectValue = v"/>
                    </div>
                      <button
                          type="button"
                          class="btn btn--green btn--sm-squared btn--popover"
                          data-popover="Copy rates from the previous year"
                          @click="copyPopup = true"
                      >
                        <svg width="1em" height="1em" class="icon icon-copy ">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use>
                        </svg>
                      </button>
                  </div>
                  <div class="climbing-head__second-row">
                    <span class="select-label">Prices for 2nd half of 2026</span>
                    <div style="margin-right: 10px">
                      <ClassicSwitch v-model="include2026Taxes"/>
                    </div>
                    <span class="select-label">Hotels & transfers included</span>
                    <div style="margin-right: 10px">
                      <ClassicSwitch v-model="includeHotelsAndTransfers"/>
                    </div>
                    <div class="switcher-el  switcher-el_prices" style="margin-right: 0">
                      <a href="#" :class="['switcher-el__item', {'active' : tab === 'CLASSIC'}]" @click="tab = 'CLASSIC'">
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <span class="switcher-el__text">Classic</span>
                      </a>
                      <a href="#" :class="['switcher-el__item', {'active' : tab === 'PREMIUM'}]" @click="tab = 'PREMIUM'">
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <svg width="1em" height="1em" class="icon icon-star">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-star"></use>
                        </svg>
                        <span class="switcher-el__text">Premium</span>
                      </a>
                    </div>

                  </div>
                </div>
              </div>

              <ClimbingPricesTable :costs="costs" title="Climbing Cost for Client" @update="updateClimbingCostsHandler" @changeRow="(v) => this.costs = v" @edit="(v) => isEdit = v"/>
              <ClimbingPricesTable :costs="baseCosts" title="Base Climbing Cost" @update="updateBaseClimbingCostsHandler" @changeRow="(v) => this.baseCosts = v" @edit="(v) => isEdit = v"/>
              <ClimbingPricesTable :costs="tourLeaderData" title="Climbing Cost for Tour Leader" @update="updateClimbingTourLeaderHandler" @changeRow="(v) => this.tourLeader[tab] = v" @edit="(v) => isEdit = v"/>

              <div class="details-wrapper" v-if="details.details">
                <div class="languages-group">
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'EN'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'EN'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-gb ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-gb"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">English</span>
                  </label>
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'RU'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'RU'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-rus ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-rus"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">Russian</span>
                  </label>
                  <label class="np-detail-collapse__lang np-detail-collapse__lang_checkbox"
                         @click="activeDetail = 'DE'">
                    <input type="radio" name="lanuage" :checked="activeDetail === 'DE'">
                    <div class="np-detail-collapse__lang__icon">
                      <svg width="1em" height="1em" class="icon icon-deu ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-deu"></use>
                      </svg>
                    </div>
                    <span class="np-detail-collapse__lang__text">Deutch</span>
                  </label>
                </div>
                <div class="text-edit-price-wrapper">
                  <div class="text-edit-price">
                    <div class="text-edit-price__item">
                      <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-check ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use>
                            </svg>
                          </span>
                        Inclusions
                      </div>
                      <div class="form-control-wrap">
                        <div class="text-heading">Transfers:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.transfers"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Entry fees:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.entryFees"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Accommodation:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.accommodations"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Meals:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.meals"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Hiking and safety equipment:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.hiking"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Climbing crew:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.climbingCrew"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                        <div class="text-heading">Taxes:</div>
                        <div class="text-edit-price__text">
                          <div class="js-ckeditor">
                            <editor @input="isEdit = true" :editor="editor"
                                    v-model="details.details[activeDetail].inclusion.taxes"
                                    :config="editorConfig"></editor>
                          </div>
                        </div>
                      </div>

                    </div>
                    <div class="text-edit-price__item">
                      <div class="text-edit-price__head">
                          <span class="text-edit-price__head-icon">
                            <svg width="1em" height="1em" class="icon icon-close ">
                              <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                            </svg>
                          </span>
                        Exclusions
                      </div>
                      <div class="form-control-wrap">
                        <div class="js-ckeditor">
                          <editor @input="isEdit = true" :editor="editor"
                                  v-model="details.details[activeDetail].exclusion" :config="editorConfig2"></editor>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="table-save-btn" style="margin-right: 1.2rem">
                  <button type="button" class="btn btn--green" @click="updateClimbingDetailsHandler"><span>Save</span>
                  </button>
                </div>
              </div>

            </form>
            <div class="modal-wrapper" v-if="copyPopup">
              <div class="modal-backdrop"></div>
              <div class="modal-inner">
                <div class="edit-popup edit-popup--copy-md">
                  <div class="edit-popup__header">
                    <div class="edit-popup__title">
                      <div class="edit-popup__title__icon">
                        <svg width="1em" height="1em" class="icon icon-recover">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                        </svg>
                      </div>
                      <span>Copy from another year</span>
                    </div>
                    <div class="edit-popup__close" @click="copyPopup = false">
                      <svg width="1em" height="1em" class="icon icon-close ">
                        <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                      </svg>
                    </div>
                  </div>
                  <form action="javascript:void(0)" class="edit-popup__inner">
                    <div class="edit-popup__form-2">
                      <div class="form-control-group"><span class="form-control-label">Choose year</span>
                        <div :class="['select-wrapper', { 'is-active' : copyPopupOpen }]"
                             @click="copyPopupOpen = !copyPopupOpen">
                          <div class="select-trigger"><span
                              class="select-trigger__name">{{ copyPopupFrom }}</span><span
                              class="select-trigger__icon">
										<svg width="1em" height="1em" class="icon icon-chevron ">
										<use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
										</svg></span></div>
                          <div class="select-body">
                            <div class="select-inner js-scrollbar">
                              <div v-for="(y, index) in yearsSelectData.filter(year => year !== yearSelectValue.name)" :key="index"
                                   :class="['select-option', { 'is-selected' : copyPopupFrom === y }]"
                                   @click="copyPopupFrom = y"><span class="select-option__name">{{ y }}</span></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <button type="submit" class="btn btn--green edit-popup__submit-2"
                              @click="copyYearOldHandler();copyPopup = false">
                        <svg width="1em" height="1em" class="icon icon-recover">
                          <use xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-recover"></use>
                        </svg>
                        <span>Copy</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>


<script>

import {
  getClimbingDetails,
  updateClimbingDetails,
  getClimbingTourLeader,
  updateClimbingTourLeader,
  getPartners,
  getClimbingCostsV2,
  updateClimbingCostsV2,
  getBaseClimbingCostsV2,
  updateBaseClimbingCostsV2,
} from '@/utilites/api'
import {TheMask} from 'vue-the-mask'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@/utilites/ckeditor'
import ClassicSelect from "@/components/UI/ClassicSelect/ClassicSelect.vue";
import ClassicSwitch from "@/components/UI/Switch/ClassicSwitch.vue";
import ClimbingPricesTable from "@/components/PricesTable/ClimbingPricesTable.vue";

export default {
  data() {
    return {
      include2026Taxes: false,
      includeHotelsAndTransfers: true,
      fromNationalPark: true,
      copyPopup: false,
      copyPopupOpen: false,
      copyPopupFrom: '',
      editor: ClassicEditor,
      editorConfig: {
        placeholder: 'Description'
      },
      editorConfig2: {
        placeholder: 'Exclusions'
      },
      costs: [],
      baseCosts: [],
      tourLeader: {},
      operators: null,
      operatorSelectedValue: null,
      permitTypeSelectData: [
        {id: 'FOREIGN', name: 'Foreign'},
        {id: 'RESIDENCE', name: 'Resident'},
        {id: 'EAST_AFRICAN', name: 'East African'}
      ],
      permitTypeSelectedValue: {id: 'FOREIGN', name: 'Foreign'},
      ageSelectData: [
        {id: 'CHILD', name: 'Child / Teenager'},
        {id: 'ADULT', name: 'Adult'}
      ],
      ageSelectedValue: {id: 'CHILD', name: 'Child / Teenager'},
      details: {
        details: {
          EN: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }, RU: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }, DE: {
            inclusion: {
              "transfers": "",
              "entryFees": "",
              "accommodations": "",
              "meals": "",
              "hiking": "",
              "climbingCrew": ""
            }, exclusion: ''
          }
        }
      },
      discounts: {},
      activeDetail: 'EN',
      tab: 'CLASSIC',
      isLoad: false,
      yearSelect: false,
      isEdit: false,
      discountsData: [],
      tourLeaderData: [],
      yearSelectValue: {id: new Date().getFullYear(), name: new Date().getFullYear()},
      yearsSelectData: [2021,2022,2023,2024,2025,2026,2027,2028,2029,2030],
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.isEdit) {
      this.$emit('notLeaveHandler')
    }
    next()
  },
  beforeCreate() {
    document.title = 'Climbing / Prices'
  },
  components: {ClimbingPricesTable, ClassicSwitch, ClassicSelect, editor: CKEditor.component, TheMask},
  props: ['user'],
  computed: {
    formattedOperators() {
      return this.operators.map((o) => ({id: o.id, name: o.companyName}));
    },
    formattedYears() {
      return this.yearsSelectData.map((y) => ({id: y, name: y}))
    }
  },
  mounted() {
    document.title = 'Climbing / Prices'
      Promise.allSettled(
          [
            getClimbingDetails(this.user.access_token, 'CLASSIC'),
            getPartners(),
            getBaseClimbingCostsV2(
                this.yearSelectValue.id,
                this.includeHotelsAndTransfers,
                this.include2026Taxes,
                this.tab,
                this.permitTypeSelectedValue.id,
                this.ageSelectedValue.id),
          ])
          .then(res => {
            this.isLoad = true
            this.details = res[0].status === "fulfilled" ? res[0].value : this.details
            this.operators = res[1].status === "fulfilled" ? res[1].value : this.operators
            this.operatorSelectedValue = res[1].status === "fulfilled" ? res[1].value[0] : this.operatorSelectedValue
            this.baseCosts = res[2].status === "fulfilled" ? res[2].value : this.baseCosts
            return Promise.allSettled([
              getClimbingCostsV2(
                  this.yearSelectValue.id,
                  this.includeHotelsAndTransfers,
                  this.include2026Taxes,
                  this.tab,
                  this.permitTypeSelectedValue.id,
                  this.ageSelectedValue.id,
                  this.operatorSelectedValue.id),
              getClimbingTourLeader(this.yearSelectValue.id, this.includeHotelsAndTransfers, this.include2026Taxes, this.operatorSelectedValue.id),
            ])
          }).then(res => {
        this.costs = res[0].status === "fulfilled" ? res[0].value : this.costs
        this.tourLeader = res[1].status === "fulfilled" ? res[1].value.data : this.tourLeader
      })
    window.addEventListener('click', event => {
      if (!event.target.closest('.select-wrapper')) {
        this.yearSelect = false
      }
    })
  },
  methods: {
    copyYearOldHandler() {
      Promise.allSettled(
          [
            getClimbingCostsV2(
                this.copyPopupFrom,
                this.includeHotelsAndTransfers,
                this.include2026Taxes,
                this.tab,
                this.permitTypeSelectedValue.id,
                this.ageSelectedValue.id,
                this.operatorSelectedValue.id),
            getClimbingTourLeader(this.copyPopupFrom, this.includeHotelsAndTransfers, this.include2026Taxes, this.operatorSelectedValue.id),
            getBaseClimbingCostsV2(
                this.copyPopupFrom,
                this.includeHotelsAndTransfers,
                this.include2026Taxes,
                this.tab,
                this.permitTypeSelectedValue.id,
                this.ageSelectedValue.id),
          ])
          .then(res => {
            this.isLoad = true
            this.costs = res[0].status === "fulfilled" ? res[0].value : this.costs
            this.tourLeader = res[1].status === "fulfilled" ? res[1].value.data : this.tourLeader
            this.baseCosts = res[2].status === "fulfilled" ? res[2].value : this.baseCosts
          })
    },
    updateClimbingCostsHandler(newCosts) {
      this.costs = newCosts;
      const data = {
        year: this.yearSelectValue.id,
        type: this.tab,
        residence: this.permitTypeSelectedValue.id,
        age: this.ageSelectedValue.id,
        includeHotelsAndTransfers: this.includeHotelsAndTransfers,
        include2026Taxes: this.include2026Taxes,
        operatorId: this.operatorSelectedValue.id,
        costs: this.costs.map(item => ({
          "routeId": item.routeId,
          "pax1": item.pax1,
          "pax2": item.pax2,
          "pax3": item.pax3,
          "pax4": item.pax4,
          "pax5": item.pax5,
          "pax6": item.pax6,
          "pax7": item.pax7,
          "pax8": item.pax8,
        }))
      }
      updateClimbingCostsV2(data)
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateBaseClimbingCostsHandler(newCosts) {
      this.baseCosts = newCosts;
      const data = {
        year: this.yearSelectValue.id,
        type: this.tab,
        residence: this.permitTypeSelectedValue.id,
        age: this.ageSelectedValue.id,
        includeHotelsAndTransfers: this.includeHotelsAndTransfers,
        include2026Taxes: this.include2026Taxes,
        costs: this.baseCosts.map(item => ({
          "routeId": item.routeId,
          "pax1": item.pax1,
          "pax2": item.pax2,
          "pax3": item.pax3,
          "pax4": item.pax4,
          "pax5": item.pax5,
          "pax6": item.pax6,
          "pax7": item.pax7,
          "pax8": item.pax8,
        }))
      }
      updateBaseClimbingCostsV2(data)
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateClimbingTourLeaderHandler(newCosts) {
      this.tourLeader[this.tab] = newCosts;
      updateClimbingTourLeader(this.includeHotelsAndTransfers, this.include2026Taxes, this.tourLeader[this.tab].map(item => ({
        "routeId": item.routeId,
        "type": item.type,
        "pax1": item.pax1,
        "pax2": item.pax2,
        "pax3": item.pax3,
        "pax4": item.pax4,
        "pax5": item.pax5,
        "pax6": item.pax6,
        "pax7": item.pax7,
        "pax8": item.pax8,
      })), this.yearSelectValue.id, this.operatorSelectedValue.id)
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateClimbingDetailsHandler() {
      updateClimbingDetails(this.user.access_token, {details: this.details.details, type: this.tab})
          .then(() => {
            this.$emit('confirmed')
            this.isEdit = false
          })
    },
    updateTables() {
      getClimbingCostsV2(
          this.yearSelectValue.id,
          this.includeHotelsAndTransfers,
          this.include2026Taxes,
          this.tab,
          this.permitTypeSelectedValue.id,
          this.ageSelectedValue.id,
          this.operatorSelectedValue.id)
          .then(res => {
            this.costs = res
          })
      getClimbingTourLeader(this.yearSelectValue.id, this.includeHotelsAndTransfers, this.include2026Taxes, this.operatorSelectedValue.id)
          .then(res => {
            this.tourLeader = res.data
          })
      getBaseClimbingCostsV2(
          this.yearSelectValue.id,
          this.includeHotelsAndTransfers,
          this.include2026Taxes,
          this.tab,
          this.permitTypeSelectedValue.id,
          this.ageSelectedValue.id,)
          .then(res => {
            this.baseCosts = res
          })
    }
  },
  watch: {
    tab() {
      this.isLoad = false
      getClimbingDetails(this.user.access_token, this.tab)
          .then(res => {
            this.details = res
            this.isLoad = true
          })
          .catch(() => {
            this.details = {
              details: {
                EN: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }, RU: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }, DE: {
                  inclusion: {
                    "transfers": "",
                    "entryFees": "",
                    "accommodations": "",
                    "meals": "",
                    "hiking": "",
                    "climbingCrew": ""
                  }, exclusion: ''
                }
              }
            }
            this.isLoad = true
          })
      this.updateTables();
    },
    yearSelectValue() {
      this.updateTables();
    },
    includeHotelsAndTransfers() {
      this.updateTables();
    },
    include2026Taxes() {
      this.updateTables();
    },
    operatorSelectedValue() {
      this.updateTables();
    },
    permitTypeSelectedValue() {
      this.updateTables();
    },
    ageSelectedValue() {
      this.updateTables();
    },
    tourLeader: {
      deep: true,
      handler() {
        const leaderCopy = structuredClone(this.tourLeader[this.tab]);
        this.tourLeaderData = leaderCopy.sort((a, b) => a.routeName.toLowerCase() < b.routeName.toLowerCase() ? -1 : 1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select {
  &__fields-group {
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  &-label {
    font-weight: 500;
    font-size: 1.2rem;
    color: #1b1b1b;
    line-height: 1.5em;
    margin-right: 10px;
  }
}

.climbing-head {
  &__table-title {
    margin-bottom: 15px;
  }

  &__rows {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  &__first-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
  }
  &__second-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 20px;

  }

  &__first-row, &__second-row {
    display: flex;
  }
}

.details-wrapper {
  background: #fff;
  padding-bottom: 21px;
  margin-top: 30px;
  -webkit-box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.15);
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

</style>